import React, { useState, useEffect } from "react";
import './style.css';
import { useNavigate } from "react-router-dom";
import phoenixLogo from "../../assets/phoenix_logo_white.png";

function Login() {
  const navigate = useNavigate();

  // États
  const [password, setPassword] = useState('');
  const [logged, setLogged] = useState(false);     // Pour afficher l'écran de succès
  const [loggedFail, setLoggedFail] = useState(false); // Pour afficher l'erreur

  // 1. Vérification automatique à l'arrivée sur la page
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      navigate('/');
    }
  }, [navigate]);

  // Fonction utilitaire pour gérer le succès (évite la duplication de code)
  const handleLoginSuccess = (token) => {
    localStorage.setItem("token", token);
    setLogged(true); // Affiche le logo de succès
    setLoggedFail(false); // Enlève le message d'erreur s'il était là

    // 2. On attend 1.5 seconde (1500ms) pour laisser l'utilisateur voir l'animation/logo
    // avant de le rediriger vers l'accueil.
    setTimeout(() => {
      navigate('/home');
    }, 2000);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Reset de l'état d'erreur au début de la tentative
    setLoggedFail(false);

    // Mode Démo / Backdoor locale (Si le mot de passe est juste "password")
    // On le vérifie AVANT l'appel réseau pour éviter d'attendre si on sait déjà que c'est le mode démo
    if (password === "Phoenix@12@11") {
      const fakeToken = "demo-token-" + Math.random().toString(36).substr(2, 9);
      handleLoginSuccess(fakeToken);
      return; // On arrête la fonction ici
    }

    try {
      const res = await fetch("/api/password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password })
      });

      const data = await res.json();

      if (res.ok) {
        // Succès API normal
        handleLoginSuccess(data.token);
      } else {
        // Erreur API (Mauvais mot de passe envoyé au serveur)
        setLoggedFail(true);
      }

    } catch (error) {
      console.error("Erreur réseau:", error);
      // En cas d'erreur réseau (serveur éteint), on affiche juste l'erreur
      // (Le mode démo "password" est déjà géré plus haut)
      setLoggedFail(true);
    }
  };

  return (
      <div id="login">
        {/* Si connecté, on affiche l'écran de transition avec le logo */}
        {logged ? (
              <div id="logged" className="animation"> {/* Ajoutez une classe CSS fade-in pour l'effet */}
              <img id="logo-logged" src={phoenixLogo} alt="Phoenix Logo Success"/>
              {/* Optionnel : Un petit message de bienvenue */}
              <h1>Bienvenue</h1>
            </div>
        ) : (
            <div id="not-logged">
              {/* J'ai retiré le ref inutile ici */}
              <img id="logo-not-logged" className="animation" src={phoenixLogo} alt="Phoenix Logo"/>

              <h2>Veuillez saisir le mot de passe ci-dessous.</h2>

              <form onSubmit={handleSubmit}>
                <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="mot de passe"
                    autoFocus // Petit bonus UX : le curseur est déjà dans la case
                />
                <input type="submit" value="Entrer"/>
              </form>

              <div id="failed-message">
                {/* Utilisation d'une classe CSS pour le rouge c'est mieux */}
                {loggedFail && <p style={{color: '#ff6b6b'}}>Mot de passe incorrect</p>}
              </div>
            </div>
        )}
      </div>
  );
}

export default Login;